import Countdown from 'react-countdown'
import { useTranslation } from 'react-i18next'

function SolvencyRenderer({ deadline }: any) {
  const { t } = useTranslation()
  const renderer = ({ days, hours, minutes, seconds, completed }: any) => {
    if (completed) {
      return <span>{t('solvency_renderer')}</span>
    }
    return (
      <span>
        {t('after')}: {days} {t('days')}, {hours} {t('hours')}, {minutes}{' '}
        {t('minutes')}, {seconds} {t('seconds')}, {t('solvency_renderer_txt')}
      </span>
    )
  }
  return (
    <Countdown
      date={new Date(deadline).getTime() - 24 * 60 * 60 * 1000}
      renderer={renderer}
    />
  )
}

export default SolvencyRenderer
